import * as ReactDOM from 'react-dom/client';
import tipImg from '@/assets/image/orientation-tip.png';

import cx from './index.module.scss';

const MASK_DOM_ID = 'orientation-tip-mask';

let removeFn = null;

const OrientationTipMask = {
  show: () => {
    const maskContainer = document.getElementById(MASK_DOM_ID);
    if (!!maskContainer) return;

    const container = document.createElement('div');
    container.id = MASK_DOM_ID;
    document.body.appendChild(container);

    let root = ReactDOM.createRoot(document.getElementById(MASK_DOM_ID));
    root.render(
      <div className={cx('OrientationTipMask')}>
        <div className={cx('wrapper')}>
          <img className={cx('tip-img')} src={tipImg} alt="" />
          <div>请将屏幕旋转为竖直状态</div>
        </div>
      </div>
    );

    const remove = (onOk?: VoidFunc) => {
      if (!root) {
        onOk?.();
        return;
      }
      setTimeout(() => {
        root.unmount();
        root = null;
        const container = document.getElementById(MASK_DOM_ID);
        container && document.body.removeChild(container);
        onOk?.();
      }, 0);
    };

    removeFn = remove;
  },
  hide: (onOk?: VoidFunc) => {
    removeFn?.(onOk);
  },
};

export default OrientationTipMask;
